import { Spacer, Button, Divider } from '@cleartrip/bento'

import Modal from 'lib/Modal'
import React from 'react'

const SpecialFareModal = props => {
    const { isShowing, toggle } = props

    return (
        <Modal isShowing={isShowing} toggle={toggle} onOverlayClick={toggle} isCross={true} overlayClassName="z-80">
            <div
                className="bg-white br-16 pb-8 px-6 pt-6"
                style={{
                    width: '512px',
                    minHeight: '200px',
                    maxHeight: '312px'
                }}
            >
                <svg width="72" height="72" viewBox="0 0 72 72" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect width="72" height="72" rx="36" fill="#FFF1EC" />
                    <rect x="8" y="4" width="56" height="56" />
                    <g mask="url(#mask0_881_2886)">
                        <path
                            d="M17.627 50.6665C17.2638 50.6665 16.9423 50.5802 16.6625 50.4074C16.3828 50.2347 16.1652 50.0069 16.0097 49.7242C15.8402 49.446 15.747 49.1447 15.73 48.82C15.7131 48.4955 15.8039 48.1682 16.0024 47.8382L34.3696 16.1614C34.5682 15.8315 34.8073 15.5917 35.087 15.4421C35.3667 15.2926 35.6711 15.2178 36.0002 15.2178C36.3292 15.2178 36.6336 15.2926 36.9133 15.4421C37.193 15.5917 37.4321 15.8315 37.6307 16.1614L55.9979 47.8382C56.1964 48.1682 56.2872 48.4955 56.2703 48.82C56.2533 49.1447 56.1601 49.446 55.9906 49.7242C55.8351 50.0069 55.6175 50.2347 55.3378 50.4074C55.058 50.5802 54.7365 50.6665 54.3733 50.6665H17.627ZM18.3835 48.3332H53.6168L36.0002 17.9999L18.3835 48.3332ZM36.0002 45.1024C36.407 45.1024 36.748 44.9648 37.0233 44.6896C37.2984 44.4144 37.436 44.0734 37.436 43.6665C37.436 43.2597 37.2984 42.9186 37.0233 42.6434C36.748 42.3682 36.407 42.2307 36.0002 42.2307C35.5933 42.2307 35.2523 42.3682 34.977 42.6434C34.7019 42.9186 34.5643 43.2597 34.5643 43.6665C34.5643 44.0734 34.7019 44.4144 34.977 44.6896C35.2523 44.9648 35.5933 45.1024 36.0002 45.1024ZM36.0017 39.8973C36.3328 39.8973 36.6097 39.7855 36.8325 39.5618C37.0554 39.3382 37.1668 39.0612 37.1668 38.7306V29.3973C37.1668 29.0668 37.0549 28.7897 36.8309 28.5661C36.6071 28.3425 36.3296 28.2307 35.9986 28.2307C35.6676 28.2307 35.3906 28.3425 35.1678 28.5661C34.9449 28.7897 34.8335 29.0668 34.8335 29.3973V38.7306C34.8335 39.0612 34.9454 39.3382 35.1694 39.5618C35.3933 39.7855 35.6707 39.8973 36.0017 39.8973Z"
                            fill="#FF4F17"
                        />
                    </g>
                </svg>
                <Spacer mt={4} />
                <div className="flex ">
                    <p className="fs-7 fw-600 c-neutral-900">{`Please note`}</p>
                </div>
                <Spacer mt={3} />
                <p className="fs-4 lh-24 fw-400 c-neutral-900">
                    Special fares like student, senior citizen and armed forces are applicable only for domestic flights
                </p>
                <Spacer mt={8} />
                <div className="flex flex-end">
                    <Button size="md" type="secondary" full onClick={toggle} className="bg-tertiary-900 hover:bg-tertiary-900 h-12 br-6 fs-4">
                        Okay, got it
                    </Button>
                </div>
            </div>
        </Modal>
    )
}

export default SpecialFareModal
